import { Components, Theme } from '@mui/material';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    fullWidth: true,
  },
  styleOverrides: {
    paper: {
      boxShadow: '0px 5px 25px 0px rgba(0, 0, 0, 0.50)',
    },
  },
};
